import { aboutData } from '@/mocks/about';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import Breadcrumb from '@/components/feature/Breadcrumb';

const breadcrumbItems = [
  { label: '首页', href: '/' },
  { label: '关于我们' },
];

export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '最新发布页',
    url: 'https://gdbtui7.cn',
    description: '汇聚平台全部最新内容，实时更新、分类清晰，让您第一时间获取最新资讯、产品、公告与活动信息。',
    email: aboutData.contact.email,
    telephone: aboutData.contact.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '海淀区',
      streetAddress: '中关村大街1号创新大厦18层',
      addressCountry: 'CN',
    },
    foundingDate: '2022',
  };

  const jsonLdFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '最新发布页是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '最新发布页是一个一站式信息聚合平台，汇聚平台全部最新内容，实时更新、分类清晰，帮助您第一时间获取最新资讯、产品、公告与活动信息。',
        },
      },
      {
        '@type': 'Question',
        name: '平台内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台采用实时更新机制，内容合作伙伴发布后即时同步到平台，确保您获取的信息始终是最新的。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过电子邮箱 contact@gdbtui7.cn、客服电话 400-888-9999 或微信公众号 zuixinfabu2022 联系我们，工作时间为周一至周五 9:00-18:00。',
        },
      },
      {
        '@type': 'Question',
        name: '平台内容是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '平台基础内容服务完全免费，所有用户均可自由浏览最新资讯、产品发布、平台公告和活动信息。部分高级功能可能需要注册账户。',
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdOrg)}</script>
      <script type="application/ld+json">{JSON.stringify(jsonLdFAQ)}</script>
      <main className="min-h-screen pt-20 pb-14">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
            关于我们
          </h1>
          <BrandIntro />
          <Reputation />
          <ContactSection />
        </div>
      </main>
    </>
  );
}